import * as _ from 'lodash';
import { AdministrationConfigModel } from '@app/core/models/administration/administration-config.model';
import { UserModel } from '@app/core/models/users/user.model';
import { GroupModel } from '@app/core/models/groups/group.model';
import { RecipientEntityModel } from '@app/core/models/recipient-entity/recipient-entity.model';
import { AssetModel } from '@app/core/models/assets/asset.model';
import { EmailTemplateModel } from '@app/core/models/emails/email-template.model';
import { WorkflowModel } from '@app/core/models/workflows/workflow.model';
import { TableColumnsConfigHelper } from '@app/core/models/configuration/table-columns-config-helper';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { ExcelExportFileName } from '../configuration/excel-export-filename.model'
import { WorkflowPromotionModel } from '../workflowsPromotion/workflow-promotion.model';

export class AdministrationComponentHelper {

    private configurations: AdministrationConfigModel[];

    constructor() {

        this.configurations = [
            {
                key: TableColumnsConfigKey.WORKFLOW,
                exportFileName: ExcelExportFileName.WORKFLOW,
                detailUrl: 'administration/workflows/detail',
                newUrl: 'administration/workflows/new',
                partialMessageName: 'le flux de validation BAP',
                displayNameExtractor: (data: WorkflowModel) => data.Name,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.WORKFLOW)
            },
            {
                key: TableColumnsConfigKey.APPROVAL,
                exportFileName: ExcelExportFileName.APPROVAL,
                detailUrl: 'administration/approvals/detail',
                newUrl: 'administration/approvals/new',
                partialMessageName: 'le flux d\'approbation',
                displayNameExtractor: (data: WorkflowModel) => data.Name,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.APPROVAL)
            },
            {
                key: TableColumnsConfigKey.WORKFLOW_PROMOTION,
                exportFileName: ExcelExportFileName.WORKFLOW_PROMOTION,
                detailUrl: 'administration/workflowsPromotion/detail',
                newUrl: 'administration/workflowsPromotion/new',
                partialMessageName: 'le flux de validation PROMOTION',
                displayNameExtractor: (data: WorkflowPromotionModel) => data.Name,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.WORKFLOW_PROMOTION)
            },
            {
                key: TableColumnsConfigKey.USER,
                exportFileName: ExcelExportFileName.USER,
                detailUrl: 'administration/users/detail',
                newUrl: 'administration/users/new',
                partialMessageName: "l'utilisateur",
                displayNameExtractor: (data: UserModel) => `${data.LastName} ${data.FirstName}`,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.USER)
            },
            {
                key: TableColumnsConfigKey.GROUP,
                exportFileName: ExcelExportFileName.GROUP,
                detailUrl: 'administration/groups/detail',
                newUrl: 'administration/groups/new',
                partialMessageName: "le groupe",
                displayNameExtractor: (data: GroupModel) => data.Name,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.GROUP)
            },
            {
                key: TableColumnsConfigKey.RECIPIENTENTITY,
                exportFileName: ExcelExportFileName.RECIPIENTENTITY,
                detailUrl: 'administration/recipient-entities/detail',
                newUrl: 'administration/recipient-entities/new',
                partialMessageName: 'la société',
                displayNameExtractor: (data: RecipientEntityModel) => data.Name,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.RECIPIENTENTITY)
            },
            {
                key: TableColumnsConfigKey.ASSET,
                exportFileName: ExcelExportFileName.ASSET,
                detailUrl: 'administration/assets/detail',
                newUrl: 'administration/assets/new',
                partialMessageName: 'la référence',
                displayNameExtractor: (data: AssetModel) => data.Reference,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.ASSET)
            },
            {
                key: TableColumnsConfigKey.EMAILTEMPLATE,
                exportFileName: ExcelExportFileName.EMAILTEMPLATE,
                detailUrl: 'administration/email-templates/detail',
                newUrl: 'administration/email-templates/new',
                partialMessageName: 'le template',
                displayNameExtractor: (data: EmailTemplateModel) => data.Label,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.EMAILTEMPLATE)
            },
            {
                key: TableColumnsConfigKey.ACTIVITYLOGS,
                exportFileName: ExcelExportFileName.ACTIVITIYLOGS,
                detailUrl: null,
                newUrl: null,
                partialMessageName: null,
                displayNameExtractor: null,
                tableColumns: new TableColumnsConfigHelper().getColumnsDefinition(TableColumnsConfigKey.ACTIVITYLOGS)
            }
        ]
    }

    public getConfiguration(key: string): AdministrationConfigModel {
        return _.find(this.configurations, config => config.key.toLowerCase() === key.toLowerCase());
    }

}
